// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.berth-panel {
    padding: 20px;
    background: #fff;
    border-radius: 6px;
}

.berth-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;
}

.berth-card {
    padding: 10px;
    border: 1px solid #ccc;
    width: 180px;
    cursor: pointer;
    border-radius: 4px;
    background: #f9f9f9;
}

    .berth-card.selected {
        border-color: #007bff;
        background: #e6f0ff;
    }

.allocation-form {
    margin-top: 20px;
}

    .allocation-form label {
        display: block;
        margin-bottom: 10px;
    }

.allocate-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 8px 16px;
    margin-top: 8px;
    cursor: pointer;
    border-radius: 4px;
}

.status-msg {
    margin-top: 15px;
    font-weight: bold;
}
.main-content-container {
    display: flex;
    min-height: 80vh;
}

.main-content {
    flex: 1 1;
    padding: 20px;
    background: #f9f9f9;
}

.berth-dashboard table {
    width: 100%;
    border-collapse: collapse;
}

.berth-dashboard th, .berth-dashboard td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
}

.tabs {
    display: flex;
    border-bottom: 2px solid #ddd;
}

.tab {
    padding: 10px 20px;
    cursor: pointer;
    border-bottom: 3px solid transparent;
}

    .tab.active {
        border-color: #007bff;
        font-weight: bold;
    }

.next-button {
    margin-top: 20px;
    padding: 10px 15px;
    background: #007bff;
    color: white;
    border: none;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/PortCall/BerthManagement.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;IAEI;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;AAEJ;IACI,gBAAgB;AACpB;;IAEI;QACI,cAAc;QACd,mBAAmB;IACvB;;AAEJ;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,oCAAoC;AACxC;;IAEI;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;AAEJ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".berth-panel {\n    padding: 20px;\n    background: #fff;\n    border-radius: 6px;\n}\n\n.berth-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-top: 12px;\n}\n\n.berth-card {\n    padding: 10px;\n    border: 1px solid #ccc;\n    width: 180px;\n    cursor: pointer;\n    border-radius: 4px;\n    background: #f9f9f9;\n}\n\n    .berth-card.selected {\n        border-color: #007bff;\n        background: #e6f0ff;\n    }\n\n.allocation-form {\n    margin-top: 20px;\n}\n\n    .allocation-form label {\n        display: block;\n        margin-bottom: 10px;\n    }\n\n.allocate-btn {\n    background: #007bff;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    margin-top: 8px;\n    cursor: pointer;\n    border-radius: 4px;\n}\n\n.status-msg {\n    margin-top: 15px;\n    font-weight: bold;\n}\n.main-content-container {\n    display: flex;\n    min-height: 80vh;\n}\n\n.main-content {\n    flex: 1;\n    padding: 20px;\n    background: #f9f9f9;\n}\n\n.berth-dashboard table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.berth-dashboard th, .berth-dashboard td {\n    border: 1px solid #ccc;\n    padding: 8px;\n    text-align: left;\n}\n\n.tabs {\n    display: flex;\n    border-bottom: 2px solid #ddd;\n}\n\n.tab {\n    padding: 10px 20px;\n    cursor: pointer;\n    border-bottom: 3px solid transparent;\n}\n\n    .tab.active {\n        border-color: #007bff;\n        font-weight: bold;\n    }\n\n.next-button {\n    margin-top: 20px;\n    padding: 10px 15px;\n    background: #007bff;\n    color: white;\n    border: none;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
